module.exports = {
  AUTH_API_URL: '/api/',
}
